import React, { FC } from "react";

import { Link } from "~/ui";

export type SlideNavigationType = {
  label: string;
  href: string;
  selected: boolean;
};

type PropsType = {
  navigations: SlideNavigationType[];
  className?: string;
};

export const SlideNavigation: FC<PropsType> = ({
  navigations,
  className = "",
}: PropsType) => {
  const calculateGridClass = () => {
    const gridColsCount = navigations.length;
    switch (gridColsCount) {
      case 2:
        return "grid-cols-2";
      case 3:
        return "grid-cols-3";
      default:
        return "grid-cols-3";
    }
  };

  return (
    <div
      className={`miniTablet:sticky top-header-offset bg-white z-layout grid text-center items-center ${calculateGridClass()} border-b border-secondary-200/50 ${className}`}
    >
      {navigations.map((navigation, index) => (
        <Link
          key={`${navigation.label}-${index}`}
          to={navigation.href}
          className="relative group border-b border-solid py-3.5 border-secondary-200 text-lg transition-all duration-300 ease-in-out hover:bg-secondary-200/50"
        >
          <span
            className={`relative transition-all duration-300 ease-in-out ${
              navigation.selected
                ? "text-primary-600 pb-3.5 font-bold"
                : "text-secondary-600 font-medium group-hover:text-secondary-700"
            }`}
          >
            {navigation.label}

            {/* アクティブ状態のボーダー */}
            {navigation.selected && (
              <>
                {/* メインのボーダー */}
                <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-full h-1 bg-primary-600 transition-all duration-300 ease-in-out" />

                {/* サブトルなグロー効果 */}
                <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-full h-1 bg-primary-600/30 blur-sm transition-all duration-300 ease-in-out" />
              </>
            )}

            {/* ホバー時の効果 */}
            {!navigation.selected && (
              <div className="absolute -bottom-3.5 left-1/2 transform -translate-x-1/2 w-0 h-1 bg-secondary-400 transition-all duration-300 ease-in-out group-hover:w-full opacity-50" />
            )}
          </span>
        </Link>
      ))}
    </div>
  );
};
